import { KeycloakConfig } from './types/keycloak'

const keycloakConfig: KeycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || '',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || '',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '',
  clientSecret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET || '',
  clientIdAdmin: process.env.REACT_APP_ADMIN_CLIENT_ID || '',
  clientSecretAdmin: process.env.REACT_APP_ADMIN_CLIENT_SECRET || '',
  adminUrl: process.env.REACT_APP_ADMIN_KEYCLOAK_URL || '',
  registerUrl: process.env.REACT_APP_KEYCLOAK_USER || '',
  adminUsername: process.env.REACT_APP_ADMIN_USERNAME || '',
  adminPassword: process.env.REACT_APP_ADMIN_PASSWORD || '',
}

export default keycloakConfig
